import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TaxComponent } from '../tax/tax.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tax-list',
  templateUrl: './tax-list.component.html',
  styleUrls: ['./tax-list.component.css']
})
export class TaxListComponent implements OnInit {

  public menu_item_id = '38';

  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['acct_number', 'tax_name_ar', 'tax_name_en', 'tax_perc', 'tax_amount', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<TaxComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'tax', 'tax_name_ar': '', 'tax_name_en': '', 'tax_perc': '', 'tax_amount': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    let condition = "";

    if (this.model['tax_name_ar'] != '')
      condition = " (`tax_name_ar` LIKE '%" + this.model['tax_name_ar'] +
        "%' OR `tax_name_en` LIKE '%" + this.model['tax_name_ar'] + "%') AND ";

    let query = "SELECT * FROM `tax` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
         
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newTaxEntry() {
    this.addDialogRef = this.dialog.open(TaxComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }
  editTax(row) {
    let dialog_data = {
      'table_name': 'tax', 
      'tax_id': row.tax_id,
      'acct_number': row.acct_number,
      'tax_name_ar': row.tax_name_ar, 
      'tax_name_en': row.tax_name_en,
      'tax_perc': row.tax_perc, 
      'tax_amount': row.tax_amount, 
      'key': 'tax_id',
      'flag': 'update', 
      'comment': row.comment
    };

    this.addDialogRef = this.dialog.open(TaxComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delTax(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'tax_id': row.tax_id },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }
}
